// extracted by mini-css-extract-plugin
export default {"inputBox":"JCi4LdWmKD_P_MItydNy","paymentDetailsBox":"riIClCv_AJ6q9UGYUaST"};